export default __webpack_public_path__ + "static/media/hmd_xl3.ee1d47af.png";